// src/api/services/productService.js
import axios from "../config/axiosInstance";
import endpoints from "./endpoints";

export const getDashboard = async (details) => {
  const response = await axios.post(endpoints.getDashboardDetails, details);
  return response;
};

export const getDashboardHeaders = async (details) => {
  const response = await axios.post(endpoints.getDashboardHeaders, details);
  return response;
};

export const getTopSellingItems = async (details) => {
  const response = await axios.post(endpoints.getTopSellingItems, details);
  return response;
};
